module.exports = __webpack_public_path__ + "img/@logo_kipo.a57d7a37.png";